import { ReactNode } from 'react';

import { numberUtils } from '@pukka/common/utils';
import { Shimmer, Text } from '@pukka/ui-components';
import { twMerge } from 'tailwind-merge';

interface BillingPriceSummaryDetailProps {
  readonly label: ReactNode;
  readonly price: number;
  readonly loading?: boolean;
  readonly bigLabel?: boolean;
  readonly children?: ReactNode;
  readonly className?: string;
}

function BillingPriceSummaryDetail({ label, price, bigLabel, loading, children, className }: BillingPriceSummaryDetailProps) {
  const amount = `Rp ${numberUtils.formatCurrency(Math.abs(price))}`;

  return (
    <div className={twMerge('px-4 py-2', className)}>
      <div className="flex flex-row justify-between gap-4">
        <Text variant={bigLabel ? 'title-2' : 'subtitle-1'} weight="bold">
          {label}
        </Text>
        {loading ? (
          <Shimmer size="lg" className="w-32" />
        ) : (
          <Text variant={price < 0 ? 'subtitle-1' : 'title-2'} weight="bold" className="text-right">
            {price <= 0 ? `(${amount})` : amount}
          </Text>
        )}
      </div>
      {children}
    </div>
  );
}

export { BillingPriceSummaryDetail };
